import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'keypair-option-launch-select-dropdown',
  templateUrl: './keypair.dropdown.launch.component.html',
  styleUrls: ['./keypair.dropdown.launch.component.css'],
})
export class KeyLaunchDropdownComponent implements OnInit, OnDestroy {
  @Input() key: any;
  ngOnInit(): void {}

  constructor() {}

  ngOnDestroy(): void {}
}
